import './styles/footer.css'

export default props => {
    return (
        <footer>
            <p>Developed by <a target="_blank" href="https://www.instagram.com/bergue69/">@bergue69</a></p>
        </footer>
    )
}